module.exports = "/assets/760bc74383a7964c0b7028f9a41f3dc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BK.png
// module id = 2362
// module chunks = 0